import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useNavUtils } from "../utils/navUtils";
import "../styles/components/Logout.css";

// Logout component that handles user logout.
const Logout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logoutReset } = useNavUtils();

  useEffect(() => {
    const performLogout = async () => {
      console.log("performLogout");
      await logoutReset(true);

      // Redirect to login page
      const params = new URLSearchParams(location.search);
      navigate(params.toString() ? `/login?${params.toString()}` : "/login");
    };

    performLogout();
  }, [navigate, location.search, logoutReset]);

  return (
    <div className="logout-container">
      <div className="logout-message">Logging out...</div>
    </div>
  );
};

export default Logout;
